import { packageEntryAPI } from "./api";

export const getPresetKitTypes = async () => {
  try {
    const res = await packageEntryAPI.getPresetKitTypes();
    return res || [];
  } catch (e) {}
};

export const getRoughFinishingData = async (
  presetKitId,
  placementTypeId,
  workSetId
) => {
  try {
    const res = await packageEntryAPI.getRoughFinishingList(
      presetKitId,
      placementTypeId,
      workSetId
    );
    return res || [];
  } catch (e) {}
};

export const getPlacementTypes = async (presetKitId) => {
  try {
    const res = await packageEntryAPI.getPlacementTypesList(presetKitId);
    return res || [];
  } catch (e) {}
};

export const getWorkSets = async (presetKitId) => {
  try {
    const res = await packageEntryAPI.getWorkSetsList(presetKitId);
    return res || [];
  } catch (e) {}
};

export const getUnits = async () => {
  try {
    const res = await packageEntryAPI.getUnits();
    return res || [];
  } catch (e) {}
};

export const addWorkSet = async (data) => {
  try {
    const res = await packageEntryAPI.createWorkSet(data);
    return res || {};
  } catch (e) {}
};

export const getScreedData = async (params = {}) => {
  try {
    const res = await packageEntryAPI.getScreedList(params);
    return res || [];
  } catch (e) {}
};

export const createScreedItem = async (data) => {
  try {
    const res = await packageEntryAPI.createScreed(data);
    return res || {};
  } catch (e) {}
};

export const updateScreedItem = async (id, data) => {
  try {
    const res = await packageEntryAPI.updateScreed(id, data);
    return res || {};
  } catch (e) {}
};

export const deleteScreedItem = async (id) => {
  try {
    const res = await packageEntryAPI.deleteScreed(id);
    return res || {};
  } catch (e) {}
};

export const searchMaterials = async (material_name, signal) => {
  try {
    const res = await packageEntryAPI.searchMaterials(
      { material_name },
      signal
    );
    return res?.data?.map((item) => ({
      ...item,
      label: `${item.material_id} - ${item.material_name}`,
    }));
  } catch (e) {}
};

export const getMaterialSets = async (material_id) => {
  try {
    const res = await packageEntryAPI.getMaterialSets(material_id);
    return res;
  } catch (e) {}
};
export const getSetInfo = async (material_set_id) => {
  try {
    const res = await packageEntryAPI.getSetInfo(material_set_id);
    return res?.data;
  } catch (e) {}
};
export const createMaterialSet = async (data) => {
  try {
    const res = await packageEntryAPI.createMaterialSet(data);
    return res;
  } catch (e) {}
};

export const addPackageEntry = async (body) => {
  try {
    const res = await packageEntryAPI.addPackageEntry(body);
    return res;
  } catch (e) {}
};

export const deletePackageEntry = async (data) => {
  try {
    const res = await packageEntryAPI.deletePackageEntry(data);
    return res || {};
  } catch (e) {}
};

export const updPackageEntry = async (body) => {
  try {
    const res = await packageEntryAPI.updPackageEntry(body);
    return res || {};
  } catch (e) {}
};
export const getPackagePurchaseTypes = async () => {
  try {
    const res = await packageEntryAPI.getPackagePurchaseTypes();
    // api.getPackagePurchaseTypes возвращает объект { data: [...] }
    // здесь приводим к чистому массиву типов закупки
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const getPackageMaterials = async (preset_kit_id) => {
  try {
    const res = await packageEntryAPI.getPackageMaterials(preset_kit_id);
    return res?.data;
  } catch (e) {}
};
export const updPackageMaterial = async (body) => {
  try {
    const res = await packageEntryAPI.updPackageMaterial(body);
    return res?.data;
  } catch (e) {}
};
export const getConstructivesList = async (params) => {
  try {
    const res = await packageEntryAPI.getConstructivesList(params);
    return res?.data;
  } catch (e) {}
};
export const getCompanyList = async () => {
  try {
    const res = await packageEntryAPI.getCompanyList();
    return res?.data;
  } catch (e) {}
};
export const getMainProvidersList = async () => {
  try {
    const res = await packageEntryAPI.getMainProvidersList();
    return res?.data;
  } catch (e) {}
};
export const getConstructivesPriceList = async (body) => {
  try {
    const res = await packageEntryAPI.getConstructivesPriceList(body);
    return res?.data;
  } catch (e) {}
};
export const deleteConstructivesPrice = async (contractor_work_set_tariff_id) => {
  try {
    const res = await packageEntryAPI.deleteConstructivesPrice(contractor_work_set_tariff_id);
    return res?.data;
  } catch (e) {}
};
export const addConstructivesPrice = async (body) => {
  try {
    const res = await packageEntryAPI.addConstructivesPrice(body);
    return res?.data;
  } catch (e) {}
};
export const updConstructivesPrice = async (body) => {
  try {
    const res = await packageEntryAPI.updConstructivesPrice(body);
    return res?.data;
  } catch (e) {}
};

export const addConstructive = async (body) => {
  try {
    const res = await packageEntryAPI.addConstructive(body);
    return res?.data;
  } catch (e) {}
};

export const updConstructive = async (body) => {
  try {
    const res = await packageEntryAPI.updConstructive(body);
    return res?.data;
  } catch (e) {}
};

export const getConstructiveList = async () => {
  try {
    const res = await packageEntryAPI.getConstructiveList();
    return res?.data;
  } catch (e) {}
};

export const getGoupConstructiveList = async () => {
  try {
    const res = await packageEntryAPI.getGoupConstructiveList();
    return res?.data;
  } catch (e) {}
};

export const getGroupConstructive = async (work_set_check_group_id) => {
  try {
    const res = await packageEntryAPI.getGroupConstructive(work_set_check_group_id);
    return res?.data;
  } catch (e) {}
};

export const addGroupConstructive = async (body) => {
  try {
    const res = await packageEntryAPI.addGroupConstructive(body);
    return res?.data;
  } catch (e) {}
};

export const removeConstructiveFromProvider = async (contractor_work_set_id, params) => {
  try {
    const res = await packageEntryAPI.removeConstructiveFromProvider(contractor_work_set_id, params);
    return res?.data;
  } catch (e) {}
};

export const getPresetTypes = async () => {
  try {
    const res = await packageEntryAPI.getPresetTypes();
    // API может возвращать либо { data: [...] }, либо просто массив [...]
    // Проверяем структуру и возвращаем в едином формате
    if (res && typeof res === 'object' && 'data' in res) {
      return res;
    }
    // Если это массив, оборачиваем в объект с data
    if (Array.isArray(res)) {
      return { data: res };
    }
    return { data: [] };
  } catch (e) {
    return { data: [] };
  }
};

export const getSbsInagroKonstruktiv = async () => {
  try {
    const res = await packageEntryAPI.getSbsInagroKonstruktiv();
    // API может возвращать либо { data: [...] }, либо просто массив [...]
    // Проверяем структуру и возвращаем в едином формате
    if (res && typeof res === 'object' && 'data' in res) {
      return res;
    }
    // Если это массив, оборачиваем в объект с data
    if (Array.isArray(res)) {
      return { data: res };
    }
    return { data: [] };
  } catch (e) {
    return { data: [] };
  }
};

export const createPresetKit = async (data) => {
  try {
    const res = await packageEntryAPI.createPresetKit(data);
    return res || {};
  } catch (e) {}
};

export const createPlacementType = async (data) => {
  try {
    const res = await packageEntryAPI.createPlacementType(data);
    return res || {};
  } catch (e) {}
};

export const getAllPlacementTypes = async () => {
  try {
    const res = await packageEntryAPI.getAllPlacementTypes();
    // API может возвращать либо { data: [...] }, либо просто массив [...]
    // Проверяем структуру и возвращаем в едином формате
    if (res && typeof res === 'object' && 'data' in res) {
      return res;
    }
    // Если это массив, оборачиваем в объект с data
    if (Array.isArray(res)) {
      return { data: res };
    }
    return { data: [] };
  } catch (e) {
    return { data: [] };
  }
};

export const packageTableColumns = [
  {
    name: "placement_type_name",
    required: true,
    label: "Тип помещения",
    align: "left",
    field: "placement_type_name",
    sortable: true,
  },
  {
    name: "work_set_name",
    required: true,
    label: "Конструктив",
    align: "left",
    field: "work_set_name",
    sortable: true,
  },
  {
    name: "set_name",
    required: true,
    label: "Набор",
    align: "left",
    field: "set_name",
    sortable: true,
  },
  {
    name: "material_name",
    required: true,
    label: "Материалы",
    align: "left",
    field: "material_name",
    sortable: true,
  },
  {
    name: "actions",
    required: true,
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];

export const packageMaterialsColumns = [
  {
    name: "material_id",
    label: "ID",
    align: "center",
  },
  {
    name: "material_name",
    label: "Материал",
    align: "left",
  },
  {
    name: "purchase_type_id",
    label: "Закупка",
    align: "center",
  },
  {
    name: "actions",
    label: "",
    align: "center",
  },
];

export const projectMaterialsColumns = [
  ...packageMaterialsColumns.slice(0, 2),
  {
    name: "material_count",
    label: "Кол-во",
    align: "right",
  },
  {
    name: "consume_unit_name",
    label: "Ед. изм.",
    align: "left",
  },
  {
    name: "material_price",
    label: "Цена",
    align: "right",
  },
  {
    name: "material_amount_sum",
    label: "Сумма",
    align: "right",
  },
  ...packageMaterialsColumns.slice(2),
];

export const constructivesColumns = [
  {
    name: "work_set_id",
    label: "ID",
    align: "center",
  },
  {
    name: "work_set_name",
    label: "Конструктивы",
    align: "left",
  },
  {
    name: "formula",
    label: "Формула",
    align: "center",
  },
  {
    name: "unit_short_name",
    label: "Ед. изм.",
    align: "center",
  },
  {
    name: "work_set_price",
    label: "Цена",
    align: "center",
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
  },
];

export const constructivesPriceColumns = [
  {
    name: "work_set_id",
    label: "ID",
    align: "center",
  },
  {
    name: "work_set_name",
    label: "Цена",
    align: "center",
  },
  {
    name: "formula",
    label: "Период действия",
    align: "center",
  },
];
